/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  AdminIntroResponse,
  BodyBatchImportIntroductionsAdminIntroductionsBatchImportPost,
  DeleteIntroductionRequest,
  GetIntroductionsParams,
  HTTPValidationError,
  IntroductionCreateRequest,
  IntroductionDetails,
  UpdateMyProjectsStatusRequest,
} from './platformapi.schemas';

import getIntroductionsMutator from '../custom-axios-instance';
import batchImportIntroductionsMutator from '../custom-axios-instance';
import createIntroductionMutator from '../custom-axios-instance';
import deleteIntroductionMutator from '../custom-axios-instance';
import updateMyProjectStatusMutator from '../custom-axios-instance';
import getIntroductionByIdMutator from '../custom-axios-instance';

/**
 * Retrieves all introductions
 * @summary Get Introductions
 */
export const getIntroductions = (params?: GetIntroductionsParams, signal?: AbortSignal) => {
  return getIntroductionsMutator<AdminIntroResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/introductions/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetIntroductionsQueryKey = (params?: GetIntroductionsParams) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/admin/introductions/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetIntroductionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getIntroductions>>,
  TError = void | HTTPValidationError,
>(
  params?: GetIntroductionsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntroductions>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetIntroductionsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getIntroductions>>> = ({ signal }) =>
    getIntroductions(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getIntroductions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetIntroductionsQueryResult = NonNullable<Awaited<ReturnType<typeof getIntroductions>>>;
export type GetIntroductionsQueryError = void | HTTPValidationError;

export function useGetIntroductions<
  TData = Awaited<ReturnType<typeof getIntroductions>>,
  TError = void | HTTPValidationError,
>(
  params: undefined | GetIntroductionsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntroductions>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntroductions>>,
          TError,
          Awaited<ReturnType<typeof getIntroductions>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetIntroductions<
  TData = Awaited<ReturnType<typeof getIntroductions>>,
  TError = void | HTTPValidationError,
>(
  params?: GetIntroductionsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntroductions>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntroductions>>,
          TError,
          Awaited<ReturnType<typeof getIntroductions>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetIntroductions<
  TData = Awaited<ReturnType<typeof getIntroductions>>,
  TError = void | HTTPValidationError,
>(
  params?: GetIntroductionsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntroductions>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Introductions
 */

export function useGetIntroductions<
  TData = Awaited<ReturnType<typeof getIntroductions>>,
  TError = void | HTTPValidationError,
>(
  params?: GetIntroductionsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntroductions>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetIntroductionsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Accepts csv batch of introductions. Creates the database introduction and optionally sends notification email.
 * @summary Batch Import Introductions
 */
export const batchImportIntroductions = (
  bodyBatchImportIntroductionsAdminIntroductionsBatchImportPost: BodyBatchImportIntroductionsAdminIntroductionsBatchImportPost,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  formData.append(`file`, bodyBatchImportIntroductionsAdminIntroductionsBatchImportPost.file);

  return batchImportIntroductionsMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/introductions/batch-import`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    signal,
  });
};

export const getBatchImportIntroductionsMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof batchImportIntroductions>>,
    TError,
    { data: BodyBatchImportIntroductionsAdminIntroductionsBatchImportPost },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof batchImportIntroductions>>,
  TError,
  { data: BodyBatchImportIntroductionsAdminIntroductionsBatchImportPost },
  TContext
> => {
  const mutationKey = ['batchImportIntroductions'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof batchImportIntroductions>>,
    { data: BodyBatchImportIntroductionsAdminIntroductionsBatchImportPost }
  > = (props) => {
    const { data } = props ?? {};

    return batchImportIntroductions(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type BatchImportIntroductionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof batchImportIntroductions>>
>;
export type BatchImportIntroductionsMutationBody =
  BodyBatchImportIntroductionsAdminIntroductionsBatchImportPost;
export type BatchImportIntroductionsMutationError = void | HTTPValidationError;

/**
 * @summary Batch Import Introductions
 */
export const useBatchImportIntroductions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof batchImportIntroductions>>,
      TError,
      { data: BodyBatchImportIntroductionsAdminIntroductionsBatchImportPost },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof batchImportIntroductions>>,
  TError,
  { data: BodyBatchImportIntroductionsAdminIntroductionsBatchImportPost },
  TContext
> => {
  const mutationOptions = getBatchImportIntroductionsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Creates a new introduction based on provided pro id and either a rep id or project id.
 * @summary Create Introduction
 */
export const createIntroduction = (
  introductionCreateRequest: IntroductionCreateRequest,
  signal?: AbortSignal,
) => {
  return createIntroductionMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/introductions/create`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: introductionCreateRequest,
    signal,
  });
};

export const getCreateIntroductionMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createIntroduction>>,
    TError,
    { data: IntroductionCreateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createIntroduction>>,
  TError,
  { data: IntroductionCreateRequest },
  TContext
> => {
  const mutationKey = ['createIntroduction'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createIntroduction>>,
    { data: IntroductionCreateRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createIntroduction(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateIntroductionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createIntroduction>>
>;
export type CreateIntroductionMutationBody = IntroductionCreateRequest;
export type CreateIntroductionMutationError = void | HTTPValidationError;

/**
 * @summary Create Introduction
 */
export const useCreateIntroduction = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createIntroduction>>,
      TError,
      { data: IntroductionCreateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createIntroduction>>,
  TError,
  { data: IntroductionCreateRequest },
  TContext
> => {
  const mutationOptions = getCreateIntroductionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Deletes an introduction and any related discoveries and assignments
 * @summary Delete Introduction
 */
export const deleteIntroduction = (
  deleteIntroductionRequest: DeleteIntroductionRequest,
  signal?: AbortSignal,
) => {
  return deleteIntroductionMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/introductions/delete`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: deleteIntroductionRequest,
    signal,
  });
};

export const getDeleteIntroductionMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteIntroduction>>,
    TError,
    { data: DeleteIntroductionRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteIntroduction>>,
  TError,
  { data: DeleteIntroductionRequest },
  TContext
> => {
  const mutationKey = ['deleteIntroduction'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteIntroduction>>,
    { data: DeleteIntroductionRequest }
  > = (props) => {
    const { data } = props ?? {};

    return deleteIntroduction(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteIntroductionMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteIntroduction>>
>;
export type DeleteIntroductionMutationBody = DeleteIntroductionRequest;
export type DeleteIntroductionMutationError = void | HTTPValidationError;

/**
 * @summary Delete Introduction
 */
export const useDeleteIntroduction = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteIntroduction>>,
      TError,
      { data: DeleteIntroductionRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteIntroduction>>,
  TError,
  { data: DeleteIntroductionRequest },
  TContext
> => {
  const mutationOptions = getDeleteIntroductionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Updates the status reflected in the intro users' My Projects cards by updating the introduction and related discovery/assignments records
 * @summary Update My Project Status
 */
export const updateMyProjectStatus = (
  updateMyProjectsStatusRequest: UpdateMyProjectsStatusRequest,
  signal?: AbortSignal,
) => {
  return updateMyProjectStatusMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/introductions/update-my-project-status`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: updateMyProjectsStatusRequest,
    signal,
  });
};

export const getUpdateMyProjectStatusMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMyProjectStatus>>,
    TError,
    { data: UpdateMyProjectsStatusRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMyProjectStatus>>,
  TError,
  { data: UpdateMyProjectsStatusRequest },
  TContext
> => {
  const mutationKey = ['updateMyProjectStatus'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMyProjectStatus>>,
    { data: UpdateMyProjectsStatusRequest }
  > = (props) => {
    const { data } = props ?? {};

    return updateMyProjectStatus(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMyProjectStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMyProjectStatus>>
>;
export type UpdateMyProjectStatusMutationBody = UpdateMyProjectsStatusRequest;
export type UpdateMyProjectStatusMutationError = void | HTTPValidationError;

/**
 * @summary Update My Project Status
 */
export const useUpdateMyProjectStatus = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateMyProjectStatus>>,
      TError,
      { data: UpdateMyProjectsStatusRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateMyProjectStatus>>,
  TError,
  { data: UpdateMyProjectsStatusRequest },
  TContext
> => {
  const mutationOptions = getUpdateMyProjectStatusMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get Introduction By Id
 */
export const getIntroductionById = (introductionId: number, signal?: AbortSignal) => {
  return getIntroductionByIdMutator<IntroductionDetails>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/introductions/${introductionId}`,
    method: 'GET',
    signal,
  });
};

export const getGetIntroductionByIdQueryKey = (introductionId: number) => {
  return [`${import.meta.env['VITE_API_HOST']}/admin/introductions/${introductionId}`] as const;
};

export const getGetIntroductionByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getIntroductionById>>,
  TError = void | HTTPValidationError,
>(
  introductionId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getIntroductionById>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetIntroductionByIdQueryKey(introductionId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getIntroductionById>>> = ({ signal }) =>
    getIntroductionById(introductionId, signal);

  return { queryKey, queryFn, enabled: !!introductionId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getIntroductionById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetIntroductionByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getIntroductionById>>
>;
export type GetIntroductionByIdQueryError = void | HTTPValidationError;

export function useGetIntroductionById<
  TData = Awaited<ReturnType<typeof getIntroductionById>>,
  TError = void | HTTPValidationError,
>(
  introductionId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getIntroductionById>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntroductionById>>,
          TError,
          Awaited<ReturnType<typeof getIntroductionById>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetIntroductionById<
  TData = Awaited<ReturnType<typeof getIntroductionById>>,
  TError = void | HTTPValidationError,
>(
  introductionId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getIntroductionById>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntroductionById>>,
          TError,
          Awaited<ReturnType<typeof getIntroductionById>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetIntroductionById<
  TData = Awaited<ReturnType<typeof getIntroductionById>>,
  TError = void | HTTPValidationError,
>(
  introductionId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getIntroductionById>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Introduction By Id
 */

export function useGetIntroductionById<
  TData = Awaited<ReturnType<typeof getIntroductionById>>,
  TError = void | HTTPValidationError,
>(
  introductionId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getIntroductionById>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetIntroductionByIdQueryOptions(introductionId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
